import React, { useContext } from 'react';

import NumberFormat from 'react-number-format';
import { useNavigate } from 'react-router';

import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';

const WaitListed = () => {
  const navigate = useNavigate();
  const { appData } = useContext(UserContext);
  const approvedRateProperty = appData?.applicationFeatures?.find(
    (feature) => feature.itemType === 'ApprovedRateProperty'
  );
  const approveGrantAmount = approvedRateProperty?.value?.finalApprovedAmount
    ? approvedRateProperty?.value?.finalApprovedAmount
    : 250000;
  return (
    <Layout>
      <div className="wait-list-page">
        <div className="page-inner">
          <h2>Awaiting Selection Process</h2>
          <div className="main-message">
            <p>
              <b>Estimated Grant Amount:</b>{' '}
              <NumberFormat
                value={approveGrantAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
              />
            </p>
            <p>
              <b>What it means:</b> You have submitted a complete application and it is currently
              awaiting review for eligibility.
            </p>
            <p>
              <b>What you should do:</b> Check your email for notification about your selection
              decision. You will be either selected or not selected to move forward in the
              application process.
            </p>
          </div>
          <button className="primary-btn" onClick={() => navigate('/dashboard')}>
            Return to Dashboard
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default WaitListed;
